// src/components/Product/ProductCard/ProductInfo.js
import React from 'react';
import { CardContent, Typography, Box } from '@mui/material';

const ProductInfo = ({ product, isMobile, discountInfo }) => {
  const { hasDiscount, price, newPrice } = discountInfo;

  return (
    <CardContent sx={{ 
      p: isMobile ? 1.5 : 2, 
      pb: isMobile ? 1 : 2,
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    }}>
      <Typography
        variant={isMobile ? "body2" : "body1"}
        sx={{
          fontWeight: 500,
          mb: isMobile ? 1 : 1.5,
          height: hasDiscount 
            ? (isMobile ? '1em' : '2.4em')
            : (isMobile ? '2em' : '2.4em'),
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitLineClamp: isMobile ? 2 : 2,
          WebkitBoxOrient: 'vertical',
          color: '#333',
          fontSize: isMobile ? '0.8rem' : '1rem',
          lineHeight: isMobile ? 1.2 : 1.4
        }}
      >
        {product.name_ar}
      </Typography>

      <Box sx={{ 
        display: 'flex', 
        alignItems: isMobile && hasDiscount ? 'flex-start' : 'center',
        gap: isMobile ? 0.5 : 1,
        flexDirection: isMobile && hasDiscount ? 'column' : 'row'
      }}>
        <Typography
          variant={isMobile ? "subtitle1" : "h6"}
          sx={{ 
            fontWeight: 'bold',
            color: hasDiscount ? '#e74c3c' : '#333', // Red color for discounted price
            fontSize: isMobile ? '0.9rem' : '1.25rem'
          }}
        >
          {hasDiscount ? newPrice.toFixed(2) : price.toFixed(2)} ج.م
        </Typography>
        
        {hasDiscount && (
          <Typography
            variant="body2"
            sx={{
              textDecoration: 'line-through',
              color: '#999',
              fontSize: isMobile ? '0.75rem' : '0.9rem',
              ...(isMobile && { mt: 0.25 })
            }}
          >
            {price.toFixed(2)} ج.م
          </Typography>
        )}
      </Box>
    </CardContent>
  );
};

export default ProductInfo;
